import React from 'react';

function AboutMe() {
  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-500 h-screen">
      <header className="bg-gradient-to-l from-blue-400 via-blue-300 to-blue-300">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold leading-tight text-blue-900">
            About Me :-
          </h1>
        </div>
      </header>
      <main>
        <div className="max-w-7xl mx-auto py-2 sm:px-6 lg:px-8">
          <div className="px-2 py-2 sm:px-0">
            <p className="text-lg text-blue-200 font-mono  lg:text-xl xl:text-2xl">
            In a rapidly evolving industry, having a skilled and adaptable Frontend Developer is crucial to stay ahead. That's where I come in. With 3 years of hands-on experience in React JS and a deep understanding of HTML, CSS, Tailwind CSS, Node JS, Adobe XD, and Figma, I am well-equipped to deliver exceptional results.

Throughout my career, I have successfully developed robust applications, optimized performance, and collaborated seamlessly with cross-functional teams. My track record speaks for itself. But it doesn't stop there. With a Master's degree in Computer Applications, I have a solid educational foundation that complements my practical skills.

I am driven by a passion for continuous learning, always staying up-to-date with the latest industry trends and technologies. This allows me to bring fresh perspectives and innovative solutions to every project I undertake.

Now, I am actively seeking new opportunities to leverage my expertise and contribute to a team that shares my commitment to excellence. Let's connect and discuss how I can elevate your projects to new heights. Together, we can create extraordinary digital experiences that make a lasting impact.
            </p>
            <p className="mt-4 text-lg text-white lg:text-xl xl:text-2xl">
              {/* Additional content can be added here */}
            </p>
          </div>
        </div>
      </main>
      <style jsx>{`
        /* Custom styles */
        main {
          margin-top: 4rem;
        }
        h1 {
          font-family: 'Montserrat', sans-serif;
        }
      `}</style>
    </div>
  );
}

export default AboutMe;
